export default __webpack_public_path__ + "assets/fonts/0431e4d6ff900b21614d891ce92c5da6.woff2";